import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
} from "react-icons/fa";
import TendoLogo from "../../assets/images/tendoLogo.png";

const linkClass = "text-sm text-gray-600 hover:text-gray-900";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100 font-nunito text-gray-800 px-4 md:px-8 pb-24 lg:pb-10 pt-10">
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div className="space-y-3">
          <img
            src={TendoLogo}
            alt="Tendo logo"
            height={72}
            width={72}
            className="rounded-md"
          />
          <p className="text-sm text-gray-600">+233 54 0621335</p>
          <p className="text-sm text-gray-600">support@tendo.app</p>
          <p className="text-sm text-gray-600">
            Tendo Technologies Limited.
            <br />
            No. 10 Oshie Road, Osu - Accra.
          </p>
          <div className="flex space-x-3 pt-1 text-gray-500">
            <a
              href="https://web.facebook.com/tendohq"
              aria-label="Facebook"
              className="hover:text-gray-900"
            >
              <FaFacebook />
            </a>
            <a
              href="https://www.instagram.com/tendohq/"
              aria-label="Instagram"
              className="hover:text-gray-900"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/company/tendo-tech-hq"
              aria-label="LinkedIn"
              className="hover:text-gray-900"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://x.com/tendohq"
              aria-label="X"
              className="hover:text-gray-900"
            >
              <FaTwitter />
            </a>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-gray-900 mb-3">Sell</h3>
          <ul className="space-y-2">
            <li>
              <a href="https://tendo.app/#supplier-form" className={linkClass}>
                Sell on Tendo
              </a>
            </li>
            <li>
              <a
                href="https://tendo.app/want-to-become-a-duke-reseller-click-here-to-learn-how/"
                className={linkClass}
              >
                Tendo Sellers
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-gray-900 mb-3">About</h3>
          <ul className="space-y-2">
            <li>
              <a href="https://tendo.app/about/" className={linkClass}>
                About
              </a>
            </li>
            <li>
              <a href="https://tendo.app/privacy-policy/" className={linkClass}>
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-gray-900 mb-3">Support</h3>
          <ul className="space-y-2">
            <li>
              <a
                href="https://api.whatsapp.com/send/?phone=233503247275&text&type=phone_number&app_absent=0"
                className={linkClass}
              >
                Contact us
              </a>
            </li>
            <li>
              <a href="https://tendo.app/faqs/" className={linkClass}>
                FAQ
              </a>
            </li>
          </ul>
        </div>
      </div>

      <p className="max-w-6xl mx-auto mt-8 pt-4 border-t border-gray-100 text-xs text-gray-500">
        &copy; {new Date().getFullYear()} Tendo Soko Technologies, Inc.
      </p>
    </footer>
  );
}
